<div class="layout-container">
  <app-header *ngIf="showHeader()"></app-header>
  <main
    class="page-content"
    cdkScrollable
    *ngIf="currentRoute() !== '/login' && currentRoute().split('/')[1] !== 'onboarding'"
  >
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main>
  <main class="login-content" *ngIf="currentRoute() === '/login'">
    <router-outlet></router-outlet>
  </main>
  <main class="onboarding-content" *ngIf="currentRoute().split('/')[1] === 'onboarding'">
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="showFooter()"></app-footer>
  @if (showWenty()) {
    <app-wenty></app-wenty>
  }
  @if (showBirthdayCelebration()) {
    <app-birthday-celebration (dismissed)="onBirthdayCelebrationDismissed()" />
  }
</div>
